import React from "react"
import PropTypes from "prop-types"

import MeetingListItem from './MeetingListItem';

class UpcomingMeetingsContainer extends React.Component {

  constructor(props) {
    super(props)

    this.renderMeetings = this.renderMeetings.bind(this)
  }

  renderMeetings() {
    if(this.props.meetings.length > 0) {
      return this.props.meetings.map((meeting, i) => {
        return(
          <MeetingListItem
              key={i}
              item={meeting}
              currentUser={this.props.currentUser}
              getAllMeetings={this.props.getAllMeetings}
            />
        )
      })
    } else {
      return(
        <div style={{textAlign: 'center', marginTop: 10}}>
          <h5 className="sectionText">No upcoming meetings.</h5>
          <h5 className="sectionText">Connect, chat, then schedule a Lex.</h5>
          <div className="noMeetingImage"></div>
        </div>
      )
    }
  }

  render() {
    return(
      <div style={{marginTop: 50}}>
        <h5 className="sectionHeader">Upcoming Lexes</h5>
        {this.renderMeetings()}
      </div>
    )
  }

}

export default UpcomingMeetingsContainer;
